export type SeuIndustryType =
  | 'metal'
  | 'glass'
  | 'ligno'
  | 'ercs'
  | 'energy'
  | 'panels'
  | 'imi';

export type SeuIndustryTypeApi =
  | 'METAL'
  | 'GLASS'
  | 'LIGNO'
  | 'ERCS'
  | 'ENERGY'
  | 'PANELS'
  | 'IMI';

export const SEU_INDUSTRIES: SeuIndustryType[] = [
  'metal',
  'glass',
  'ligno',
  'ercs',
  'energy',
  'panels',
  'imi',
];
